"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPPMITMandatesService = void 0;
const buildQueryParams_1 = __importDefault(require("../../utils/buildQueryParams"));
class OPPMITMandatesService {
    constructor(authService, stage) {
        this.authService = authService;
        this.stage = stage;
        this.headers = {
            'Content-Type': 'application/json',
        };
        this.resourceHostId = `cwat-open-profile-payment-service-${this.stage}`;
    }
    async getMITMandates(merchantId) {
        const queryParams = (0, buildQueryParams_1.default)({ merchantId });
        const url = `v1/mit-mandates${queryParams}`;
        const response = await this.authService.get(this.resourceHostId, url, this.headers);
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
        return (await response.json());
    }
    async getMITMandate(mitMandateId) {
        const response = await this.authService.get(this.resourceHostId, `v1/mit-mandates/${mitMandateId}`, this.headers);
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
        return (await response.json());
    }
    async deleteMITMandates(mitMandateId) {
        const response = await this.authService.delete(this.resourceHostId, `v1/mit-mandates/${mitMandateId}`, undefined, this.headers);
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
    }
}
exports.OPPMITMandatesService = OPPMITMandatesService;
//# sourceMappingURL=OPPMITMandatesService.js.map